import { ExporoUser, IdToken } from '@/store/profile/types';

/**
 * converts exporo customer data to mangopay user structure
 */

export default (exporoUser: ExporoUser, idToken: IdToken) => {
  const user = exporoUser.naturalUser;

  return {
    ExtUserId: idToken.user_id,
    FirstName: user.firstName,
    LastName: user.lastName,
    Birthday:  Math.floor(new Date(user.birth.dateOfBirth as string).getTime() / 1000),
    Nationality: user.birth.countryOfBirth,
    CountryOfResidence: user.address.country,
    Email: idToken.email,
    Address: {
      AddressLine1: user.address.street,
      AddressLine2: user.address.streetNo,
      City: user.address.city,
      PostalCode: user.address.postalCode,
      Country: user.address.country,
    },
  };
};